import React from 'react'
import {isInt, isFloat} from './validation'
import {round} from './math'
import {FieldGroup} from './form'
import {Col} from 'react-bootstrap'

export const CFXProFormatNumber = (number, roundTo = 2) => {
  if (number === '' || number == null) {
    return 'N/A'
  } else if (isInt(number) || isFloat(number)) {
    return round(number, roundTo)
  } else {
    return number
  }
}

export const CalculatorCol = (props) => {
  const {xs = 12, sm = 6, md = 4, lg = 4, ...rest} = props

  return (
    <Col xs={xs} sm={sm} md={md} lg={lg}>
      <FieldGroup {...rest} />
    </Col>
  )
}

export const FormattedDate = (incomingDate) => {
  const incomingDateSplit = incomingDate.split('-')
  if (incomingDateSplit.length < 3) return incomingDate

  var dateComponents = incomingDateSplit.map((element) => {
    if (element.length === 1) {
      return '0' + element
    } else {
      return element
    }
  })

  return dateComponents[0] + '-' + dateComponents[1] + '-' + dateComponents[2]
}



// WEBPACK FOOTER //
// ./src/helpers/formatting.js